import { useMemo } from 'react';
import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import { EVENTS_PAGE_SIZE } from '../../utils/eventFeedModel';
import { fetchEventSearchPage } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';
import { flattenFeedPages } from './useEventsFeed';

export function useEventSearch({ query, userId, authReady }) {
  const trimmed = query.trim();

  const result = useInfiniteQuery({
    queryKey: queryKeys.events.search(trimmed, userId),
    queryFn: ({ pageParam = 0 }) =>
      fetchEventSearchPage({ query: trimmed, offset: pageParam, userId }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < EVENTS_PAGE_SIZE) return undefined;
      return allPages.length * EVENTS_PAGE_SIZE;
    },
    enabled: authReady && trimmed.length > 0,
    staleTime: STALE.feed,
    placeholderData: keepPreviousData,
  });

  const events = useMemo(() => flattenFeedPages(result.data), [result.data]);

  return { ...result, events };
}
